/**
 * 获取cookie
 * @param name cookie的key
 * @param value cookie的value
 * @param day 有效天数，不传的话只在本次会话有效
 * @param path 路径，默认根路径
 * @param domain 主机名，默认任意
 * @param secure 是否只能使用https协议发送
 * @param SameSite 限制在第三方网站中cookie是否允许携带，Strict：禁止携带，Lax：在导航到时允许，None：允许携带
 */
interface ICookies {
  name: string;
  value: string;
  day?: number | null;
  path?: string;
  domain?: string | null;
  secure?: boolean;
  SameSite?: string;
}

const set = ({
  name,
  value,
  day = null,
  path = "/",
  domain = null,
  secure = false,
  SameSite = "None",
}: ICookies): void => {
  let expires = null;
  if (day) {
    expires = new Date();
    expires.setTime(expires.getTime() + day * 24 * 3600 * 1000);
  }
  document.cookie = `${name}=${value}${
    expires === null ? "" : `; expires=${expires.toUTCString()}`
  }${path === null ? "" : `; path=${path}`}${
    domain === null ? "" : `; domain=${domain}`
  }${secure === true ? "; secure" : ""}; SameSite=${SameSite}`;
};

/**
 * 获取cookie
 * @param name cookie的key
 * @return string
 */
const get = (name: string): string | null => {
  const arg = `${name}=`;
  const alen = arg.length;
  const clen = document.cookie.length;
  let i = 0;
  while (i < clen) {
    const j = i + alen;
    if (document.cookie.substring(i, j) === arg) {
      let endstr = document.cookie.indexOf(";", j);
      if (endstr === -1) endstr = document.cookie.length;
      return unescape(document.cookie.substring(j, endstr));
    }
    i = document.cookie.indexOf(" ", i) + 1;
    if (i === 0) break;
  }
  return null;
};

export default {
  set,
  get,
};
